import { Grid, Divider } from '@mui/material';
import { Product, ProductType } from '@thro-types/leihbar';

import { useTranslation } from 'react-i18next';

import CustomCarousel from 'app/components/Carousel';
import { ResponsiveImage } from 'app/components/ResponsiveImage';
import { translations } from 'locales/i18n';

import { BundleProduct } from './components/BundleProduct';

interface Props {
  product: Product;
  setTab: (value) => void;
}
export const ImageAndBundle = ({ product, setTab }: Props) => {
  const { t } = useTranslation();
  return (
    <Grid container item xs={12} className="product-detail__leftSide">
      <Grid
        container
        item
        xs={12}
        className="product-detail__image"
        alignItems={'center'}
        justifyContent={'center'}
      >
        <ResponsiveImage src={product.image} />
      </Grid>
      {product.productType === ProductType.BUNDLE && !!product.products?.length && (
        <Grid item sx={{ alignItems: 'end', alignSelf: 'end' }} xs md>
          <Divider />
          <Grid item className="product-detail__bundleContent">
            {t(translations.pages.leihbar.product.bundle.content())}
          </Grid>
          <CustomCarousel
            images={product.products?.map(product => product.image) || []}
            itemsToShow={4}
            imageSize="small"
            className="product-detail__leftSide__carousel"
          >
            {product.products?.map(product => (
              <BundleProduct product={product} key={product.id} />
            ))}
          </CustomCarousel>
        </Grid>
      )}
    </Grid>
  );
};
